import StoreOrdering from './StoreOrdering';
import { SkeletonPageLoading } from './Skeleton';
import merchantStyles from './MerchantOrders.module.css';
import styles from './StoreOrdering.module.css';

export default function MerchantOrders({
  canViewMerchantOrders,
  permissionsLoading,
  userStoreId,
  storeName
}) {
  if (permissionsLoading) {
    return (
      <div className={`basicContainer ${merchantStyles['merchant-orders-container']}`}>
        <div className={merchantStyles['merchant-orders-wrapper']}>
          <SkeletonPageLoading />
        </div>
      </div>
    );
  }

  if (!canViewMerchantOrders) {
    return (
      <div className={`basicContainer ${merchantStyles['merchant-orders-container']}`}>
        <div className={merchantStyles['merchant-orders-wrapper']}>
          <p>Acceso denegado.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`basicContainer ${merchantStyles['merchant-orders-container']}`}>
      <div className={merchantStyles['merchant-orders-wrapper']}>
        <StoreOrdering storeName={storeName || 'Store'} />
      </div>
    </div>
  );
}
